<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6519_11813)">
      <path
        d="M16.2765 2L10.5412 5.34784H8.01855L2.28317 2L1.00972 6.89776L1.97696 9.96424L1 13.5458L2.26373 17.6996L5.89938 16.6408L8.22268 18H10.3419L12.67 16.6408L16.3057 17.6996L17.5646 13.5458L16.5876 9.96424L17.5451 6.98836L16.2765 2Z"
        fill="#0A0A0A"
      />
      <path
        d="M16.0715 9.95483L15.5611 10.2267L16.3874 13.255H12.4601L10.375 14.8049L10.6521 15.1054L10.9534 15.0672L12.2706 14.0848V15.4488L12.8344 15.6109V13.8034H16.3777L17.0485 13.5316L16.0666 9.94531L16.0715 9.95483Z"
        fill="#D075FF"
      />
      <path
        d="M13.3893 10.0985V11.1954L12.6699 10.5325H10.8473L10.7598 11.0857H12.4464L13.0928 11.6866L12.6894 11.782V12.3495L13.9434 12.049L13.9531 10.2225L13.3893 10.0938V10.0985Z"
        fill="#D075FF"
      />
      <path
        d="M12.1983 11.3184H10.9395L10.5846 12.2149L10.5117 12.6823L10.8422 12.8063L12.6844 12.3628H12.6941V11.7905L12.2032 11.3184H12.1983ZM10.954 12.3676L11.2117 11.7142H12.0331L12.3636 12.029L10.954 12.3676Z"
        fill="#BAF24A"
      />
      <path
        d="M2.47891 9.95483L2.98926 10.2267L2.15812 13.255H6.09025L8.17542 14.8049L7.89836 15.1054L7.59701 15.0672L6.27981 14.0848V15.4488L5.716 15.6109V13.8034H2.1727L1.50195 13.5316L2.48377 9.94531L2.47891 9.95483Z"
        fill="#D075FF"
      />
      <path
        d="M5.16637 10.0985V11.1954L5.88571 10.5325H7.70842L7.79591 11.0857H6.10932L5.46287 11.6866L5.86631 11.782V12.3495L4.60742 12.049V10.2225L5.16637 10.0938V10.0985Z"
        fill="#D075FF"
      />
      <path
        d="M16.3838 13.813L15.5915 16.4216L10.9546 15.072L10.6533 15.1101L10.5366 15.5251L11.8587 15.9113L10.0457 16.9701H8.50494L6.69197 15.9113L8.01402 15.5251L7.89738 15.1101L7.59603 15.072L2.9591 16.4216L2.16684 13.813L1.49609 13.5459L2.57998 17.1131L5.95318 16.1307L8.34452 17.528H10.1964L12.5926 16.1307L15.9658 17.1131L17.0497 13.5459L16.3838 13.813Z"
        fill="#89B0FF"
      />
      <path
        d="M17.0409 6.88353L15.9619 2.73926L10.6737 5.8248H7.88377L2.59556 2.73926L1.51654 6.88353L1.50195 6.92645L1.51654 6.96937L2.47891 9.95001L2.9844 10.2218H4.59323L5.15704 10.093L7.39289 8.59081L8.34554 14.6093L8.52051 14.4185H8.88505L7.88866 8.10437L8.06363 6.36849H10.489L10.664 8.10437L9.66758 14.4185H10.0321L10.2071 14.6093L11.1598 8.59081L13.3956 10.093L13.9594 10.2218H15.5682L16.0737 9.95001L17.0361 6.96937L17.0507 6.92645L17.0361 6.88353H17.0409ZM4.79251 9.67337H2.97468L2.08035 6.91213L2.91636 3.71213L7.16928 8.07101L4.78765 9.66861L4.79251 9.67337ZM7.38314 7.49397L4.40853 4.44179L7.50952 6.24925L7.38799 7.48917L7.38314 7.49397ZM11.0382 6.25401L14.1392 4.44656L11.1646 7.49873L11.0431 6.25877L11.0382 6.25401ZM15.5682 9.67817H13.7552L11.3736 8.08053L15.6363 3.7169L16.4723 6.91689L15.578 9.67817H15.5682Z"
        fill="#FF5C16"
      />
      <path
        d="M10.0263 14.4287H8.52443L7.89258 15.1107L8.20848 16.241H10.3325L10.6485 15.1107L10.0166 14.4287H10.0263ZM9.90967 15.6877H8.64107L8.51958 15.2585L8.76745 14.9867H9.77844L10.0263 15.2585L9.90482 15.6877H9.90967Z"
        fill="#BAF24A"
      />
      <path
        d="M5.86523 11.7856V12.3531H5.87498L7.71709 12.8014L8.04759 12.6774L7.9747 12.21L7.6199 11.3135H6.36101L5.87009 11.7856H5.86523ZM6.19088 12.024L6.52143 11.7093H7.34285L7.60046 12.3626L6.19088 12.024Z"
        fill="#BAF24A"
      />
    </g>
    <defs>
      <clipPath id="clip0_6519_11813">
        <rect width="17" height="16" fill="white" transform="translate(1 2)" />
      </clipPath>
    </defs>
  </svg>
</template>
